import axios from 'axios';
import { UPDATE_COURSE } from '../paths';

export const updateCourse = async (courseSteps, courseID) => {
  const body = {
    courseSteps: courseSteps.map(({ _id }) => _id),
    courseID,
  };
  const response = await axios.post(UPDATE_COURSE, body);
  return response;
};
